// Clinical disposition choices are alternatives, not simultaneous findings.
export function updateAdditionalOption(data = {}, field, checked) {
  const next = { ...data, [field]: Boolean(checked) };
  if (checked && field === 'ambulatoryCare') next.transportRefusal = false;
  if (checked && field === 'transportRefusal') next.ambulatoryCare = false;
  return next;
}